var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandChromiumStyleBrand = function SvgBrandChromiumStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandChromiumStyleBrand__clip0_3952_114130)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandChromiumStyleBrand__paint0_linear_3952_114130)",
    d: "m12 12 5.196 3L12 24c6.627 0 12-5.372 12-12a11.94 11.94 0 0 0-1.61-6H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandChromiumStyleBrand__paint1_linear_3952_114130)",
    d: "M12 0C7.558 0 3.683 2.415 1.608 6.001L6.804 15 12 12V6h10.39C20.316 2.414 16.44 0 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandChromiumStyleBrand__paint2_linear_3952_114130)",
    d: "M0 12c0 6.628 5.372 12 12 12l5.196-9L12 12l-5.196 3-5.195-8.999A11.94 11.94 0 0 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandChromiumStyleBrand__paint3_linear_3952_114130)",
    d: "M16.875 12a4.875 4.875 0 1 1-9.75 0 4.875 4.875 0 0 1 9.75 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandChromiumStyleBrand__paint0_linear_3952_114130",
    x1: 18.026,
    x2: 18,
    y1: 5.975,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFCCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB5F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandChromiumStyleBrand__paint1_linear_3952_114130",
    x1: 10.26,
    x2: 11.251,
    y1: 0.183,
    y2: 16.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1972E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1969D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandChromiumStyleBrand__paint2_linear_3952_114130",
    x1: 8.598,
    x2: 8.598,
    y1: 6.001,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#659CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandChromiumStyleBrand__paint3_linear_3952_114130",
    x1: 11.95,
    x2: 12,
    y1: 7.144,
    y2: 16.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3680F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2678EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandChromiumStyleBrand__clip0_3952_114130"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandChromiumStyleBrand);
export { ForwardRef as ReactComponent };